import config from '@/services/Config';
import axios from 'axios';
import RequestConfig from '@/services/RequestConfig';

let restModel = 'drops';
let baseUrl = config.apiBaseUrl;

export default {
  getAll(filters) {
    let filterString = '';
    if(filters && filters.where) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'where=' + JSON.stringify(filters.where);
    }
    if(filters && filters.limit) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'limit=' + filters.limit;
    }
    return axios.get(baseUrl + '/' + restModel + filterString, RequestConfig);
  },

  getAllPopulated(filters) {
    let filterString = '';
    if(filters && filters.where) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'where=' + JSON.stringify(filters.where);
    }
    if(filters && filters.limit) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'limit=' + filters.limit;
    }  
    if(filters && filters.order) {
      filterString += filterString === '' ? '?':'&';
      filterString += 'order=' + filters.order;
    }
    return axios.get(baseUrl + '/' + restModel + '/populated' + filterString, RequestConfig);
  },

  getMine(filter){
    return axios.get(baseUrl + '/' + restModel + '/mine/' + filter, RequestConfig);
  },

  getById(id) {
    return axios.get(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  getNearby(lat,lng){
    return axios.get(baseUrl + '/' + restModel + '/nearby/' + lat + '/' + lng, RequestConfig);
  },

  createOne(fields) {
    return axios.post(baseUrl + '/' + restModel, fields, RequestConfig);
  },
  
  update(id, fields) {
    return axios.put(baseUrl + '/' + restModel + '/' + id, fields, RequestConfig);
  },
  
  deleteById(id) {
    return axios.delete(baseUrl + '/' + restModel + '/' + id, RequestConfig);
  },

  getAllForToday() {
    return axios.get(baseUrl + '/' + restModel + '/today', RequestConfig);
  },

  getAllFutureBookedDrops() {
    return axios.get(baseUrl + '/' + restModel + '/future/booked', RequestConfig);
  },
  
  async cancelAllDropsForToday() {
    try {
      await axios.post(baseUrl + '/' + restModel + '/cancelAllForToday', null, RequestConfig);
      return true;
    }
    catch(err) {
      console.log('DropsService:cancelAllDropsForToday()', {err});
      return false;
    }
  },

  getAllWithUnresolvedIssues(){
    return axios.get(baseUrl + '/' + restModel + '/unresolvedIssues', RequestConfig);
  },

  updateSlack(message){
    var content = {"text":message}
    axios.post('https://hooks.slack.com/services/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', JSON.stringify(content), {'Content-Type': 'application/json'});
  }
}
